import http from '@/services/http';

export const fetchEmployeeAppleWalletPass = async (employeeId, params) => {
  try {
    const { data } = await http.get(
      `/cardfree-api/v1/wallet/employee/${employeeId}/apple`,
      {
        params,
        responseType: 'arraybuffer',
        headers: { accept: 'application/vnd.apple.pkpass' }
      }
    );

    return { data };
  }
  catch (error) {
    return { error };
  }
};

export default {
  fetchEmployeeAppleWalletPass
};
